export enum EventMailType {
    Undefined = 0,
    InvitationMail = 1,
    ConfirmationMail = 2,
    ReminderMail = 3,
    WelcomeMail = 4,
    ThankYouMail = 5,
    AdHocMail = 6,
    InternalReminderMail = 7,
    TicketMail = 8,
    SaveTheDateMail = 9,
    PaymentDocumentMail = 10,
    AdhocExpired = 20,
    AdhocNoShow = 21,
    AdhocConfirmed = 22,
    AdhocCheckedIn = 23,
    AdHocRegistered = 24
}
